export default (theme) => {
    return {
        root: {
            position: 'relative',
            fontFamily: 'inherit',
        },
        trigger: {
            display: 'flex',
            gap: 8,
            alignItems: 'center',
            cursor: 'pointer',
            userSelect: 'none',
            outline: 'none',
        },
        popoverRoot: {
            // Override default Popover maxWidth for menu
            maxWidth: 'none',
        },
        popoverContent: {
            // Override default Popover padding for menu
            padding: 0,
        },
        menu: {
            width: (props) => props.popupSize,
            minWidth: 'auto',
            padding: '18px 10px',
        },
        menuItem: {
            padding: '8px 12px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            listStyle: 'none',
            userSelect: 'none',
            ...theme.typography.subtitle,
        },
        itemIcon: {
            marginRight: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        menuItemContent: {
            flex: 1,
        },
        clickable: {
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: theme.colors.actionMinor[50],
            },
        },
        divider: {
            width: '100%',
            height: '1px',
            margin: '4px 0',
            backgroundColor: theme.colors.grey[100],
        },
    };
};
